<template>
  <div v-if="!hideToolTip">
    <!--Tooltip content-->
    <div
      class="absolute flex flex-col text-white py-3 px-4 rounded-md z-20 bg-surface-primary"
      :class="[heightClasses]"
      :style="{
        top: `${tooltipCoords.top - 20}px`,
        left: `${tooltipCoords.left}px`,
        transform: `translate(${tooltipTransformX}, -99%)`,
        width: `${tooltipWidth}px`,
      }"
    >
      <div class="text-lg" id="tooltip_text">{{ tooltipText }}</div>
      <div class="text-3xl font-bold">${{ table.price_per_person }}</div>
      <div class="text-lg" v-if="table.maximum_guests > 1">per person</div>
    </div>

    <!--Little Triangle Down-->
    <div
      class="absolute h-4 w-8 bottom-0 left-1/2 transform -translate-x-1/2 z-30 bg-surface-primary"
      style="clip-path: polygon(50% 100%, 0 0, 100% 0)"
      :style="{
        top: `${tooltipCoords.top - 20}px`,
        left: `${tooltipCoords.leftCenter}px`,
      }"
    />
    <!--Extra background div for displaying near the right edge of the TLV-->
    <div
      class="absolute w-12 bg-surface-primary rounded-md"
      :class="[heightClasses]"
      :style="{
        top: `${tooltipCoords.top - 20}px`,
        left: `${tooltipCoords.left - 10}px`,
        transform: `translateY(-99%)`,
      }"
    />
  </div>
</template>

<script lang="ts">
import { mapStores } from 'pinia'
import { PropType, defineComponent } from 'vue'

import { useSettingStore } from '@/stores/setting'

import { PerformanceTableRead, TableTypeRead } from '@generated/types'

interface TooltipCoords {
  top: number
  left: number
  leftCenter: number
}

interface ElementCoords {
  top: number
  left: number
  width: number
}

export default defineComponent({
  props: {
    hideToolTip: {
      type: Boolean,
      required: false,
    },
    table: {
      type: Object as PropType<PerformanceTableRead>,
      required: true,
    },
    shapeElementCoords: {
      type: Object as PropType<ElementCoords>,
      required: true,
    },
    parentElementCoords: {
      type: Object as PropType<ElementCoords>,
      required: true,
    },
  },
  computed: {
    ...mapStores(useSettingStore),

    tooltipText(): string {
      if (!this.table) {
        return 'Unknown'
      }

      let size: string = ''
      if (this.table.minimum_guests == this.table.maximum_guests) {
        if (this.table.minimum_guests == 1) {
          size = '1 guest'
        } else {
          size = `${this.table.minimum_guests} guests`
        }
      } else {
        size = `${this.table.minimum_guests}-${this.table.maximum_guests} guests`
      }

      const tableType: TableTypeRead = this.settingStore.tableType(this.table.type_id)
      if (this.table.standing_room) {
        return `${this.table.name}: ${this.table.available_guests} Available`
      } else {
        return `${tableType.name}: ${size}`
      }
    },
    tooltipWidth(): number {
      return this.tooltipText.length * 13
    },
    tooltipTransformX(): string {
      const percentage: number = Math.round(
        (this.tooltipCoords.left / this.parentElementCoords.width) * 100,
      )
      return `${5 - percentage}%`
    },
    tooltipCoords(): TooltipCoords {
      return {
        left: this.shapeElementCoords.left - this.parentElementCoords.left,
        leftCenter:
          this.shapeElementCoords.left -
          this.parentElementCoords.left +
          this.shapeElementCoords.width / 2,
        top: this.shapeElementCoords.top - this.parentElementCoords.top,
      }
    },
    heightClasses(): { [key: string]: boolean } {
      return {
        'h-20': !(this.table.maximum_guests > 1),
        'h-28': this.table.maximum_guests > 1,
      }
    },
  },
})
</script>
